<div class="grant-summary-section">
  <div class="max-w-7xl mx-auto px-3 mb-4">
    <h3 class="text-base font-bold text-gray-900 mb-3 flex items-center gap-2">
      <span class="bg-green-100 text-green-600 rounded p-1.5">
        <i class="pi pi-dollar text-base"></i>
      </span>
      Grant Summary
    </h3>
    <div class="grid grid-cols-1 md:grid-cols-3 gap-3">
      <div
        *ngFor="let card of grantCards; let i = index"
        [ngStyle]="{'animation-delay': (i * 0.1) + 's', 'background-color': card.bgColor, 'border-left': '4px solid ' + card.borderColor}"
        class="rounded-lg shadow px-4 py-3 animate-fadeInUp hover:shadow-md transition"
      >
        <!-- Top Row: Icon and Main Count -->
        <div class="flex items-start justify-between mb-1">
          <div class="flex items-center gap-2">
            <span class="rounded-full p-1.5 flex items-center justify-center" [ngStyle]="{'background-color': card.bgColor}">
              <i [class]="card.icon" [ngStyle]="{'color': card.iconColor}" class="text-base"></i>
            </span>
            <div>
              <div class="text-xs font-medium text-gray-600">{{ card.label }}</div>
              <div class="font-bold text-gray-900 text-lg">{{ card.count | number }}</div>
            </div>
          </div>
        </div>

        <!-- Scheme Breakdown - Compact Single Line -->
        <div *ngIf="card.schemeBreakdown && card.schemeBreakdown.length > 0" 
             class="mt-1 pt-1 border-t border-gray-100">
          <div class="text-[14px] text-gray-600 leading-tight whitespace-nowrap overflow-x-hidden">
            <span *ngFor="let scheme of card.schemeBreakdown; let last = last">
              <span [ngStyle]="{'color': scheme.color}" class="font-semibold">
                {{ scheme.schemeName }}:
              </span>
              <span class="font-bold text-gray-800 ml-0.5">{{ scheme.count | number }}</span>
              <span *ngIf="!last" class="text-gray-300 mx-1">|</span>
            </span>
          </div>
        </div>
      </div>
    </div>
  </div>
</div>